import {ActionContext, ActionTree} from 'vuex';
import {RootState} from '@/store/type';
import {HttpService} from '@/services/api';
import {TimeTransactionEnumApi} from '@/store/time-transaction/time-transaction.enum';
import {
  PointTransfer,
  ResponseTimeTransaction,
  TimeTransactionInitState
} from '@/store/time-transaction/time-transaction.types';

export const TimeTransactionAction: ActionTree<TimeTransactionInitState, RootState> = {

  async _transfer(req: ActionContext<TimeTransactionInitState, RootState>, body: PointTransfer): Promise<void> {
    let {dispatch, commit} = req;
    try {
      let timeTransactions = await HttpService.post(`${TimeTransactionEnumApi.timeTransaction}transfer`, body) as { data: ResponseTimeTransaction };
      await dispatch('handle/_httpResponse', timeTransactions, {root: true});
      commit('mutationTimesTransactions', timeTransactions.data.data);

    } catch (e) {
      throw e;
    }
  },
  async _getTimeTransaction(req: ActionContext<TimeTransactionInitState, RootState>, param: string): Promise<void> {
    let {commit} = req;
    try {
      let timeTransactions = await HttpService.get(`${TimeTransactionEnumApi.timeTransaction}service/transfer/${param}`) as { data: ResponseTimeTransaction };
      commit('mutationTimesTransactions', timeTransactions.data.data);
    } catch (e) {
      throw e;
    }
  },
  async _getTimeTransactionById(req: ActionContext<TimeTransactionInitState, RootState>, param: string): Promise<void> {
    let {commit, dispatch} = req;
    try {
      let timeTransactions = await HttpService.get(`${TimeTransactionEnumApi.timeTransaction}${param}`) as { data: ResponseTimeTransaction };
      await dispatch('handle/_httpResponse', timeTransactions, {root: true});
      commit('mutationTimesTransactions', timeTransactions.data.data);
    } catch (e) {
      throw e;
    }
  },

};
